<!-- <ng-container *ngIf="isLandOwner; else partner">
    <div class="animated fadeIn planting-site-detail">
        <div class="planting-primary-detail">
            <div class="row">
                <div class="col-12">
                    <div class="teaserImageBox" *ngIf="photoUrl else noImage" [appBackgroundUrl]="photoUrl">
                        <div class="teaserImageFilter haveimage">
                            <h3 *ngIf="photoUrl == null" class="placeholderimage center">Placeholder image</h3>
                        </div>
                        <div class="teaserWrapper">
                           <a class="mt-1 float-right" (click)="hideNavModal()" title="Image"><i class="icon-close"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 text-center text-desciption">
            <h5>{{description}}</h5>
        </div>
    </div>
</ng-container>

<ng-template #partner>
    <div class="animated fadeIn planting-site-detail">
        <div class="planting-primary-detail">
            <div class="row">
                <div class="col-12">
                    <div class="teaserImageBox" *ngIf="photoUrl else noImage" [appBackgroundUrl]="photoUrl">
                        <div class="teaserImageFilter haveimage"></div>
                        <div class="teaserWrapper">
                           <a class="mt-1 float-right" (click)="hideNavModal()" title="Image"><i class="icon-close"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 text-center text-desciption">
            <h5>{{description}}</h5>
        </div>
    </div>
</ng-template>

<ng-template #noImage>
    <div class="teaserImageBox">
        <div class="teaserImageFilter no-image-modal"></div>
        <div class="teaserWrapper">
           <a class="mt-1 float-right" (click)="hideNavModal()" title="Image"><i class="icon-close"></i></a>
        </div>
    </div>
</ng-template>

 -->


<!-- Modal Full screen -->
<!-- <div bsModal #contentModal="bs-modal" class="modal fade partner-details" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <a class="close" (click)="hideNavModal()" title="Image"><i class="icon-close"></i></a>
                <img class="w-100" src="{{photoUrl}}" />
            </div>
            <div class="modal-body">
                <p>
                   {{description}}
                </p>
            </div>
        </div>
    </div>
</div>
 -->

<!-- Custom by Developer -->
<ng-container tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-header">
        <ng-container *ngIf="photoUrl; else noImage">
            <img class="w-100" src="{{photoUrl}}" />
            <a class="close" (click)="hideNavModal()" title="Image"><i class="icon-close"></i></a>
        </ng-container>
        <ng-template #noImage>
            <a class="close" (click)="hideNavModal()" title="Image"><i class="icon-close"></i></a>
        </ng-template>
    </div>
    <div class="modal-body">
        <p [innerHTML]="description"></p>
    </div>
</ng-container>
